import { useEffect, useState } from "react";
import Api from "../openapi";
import { PartnerUserBriefResponse } from "../openapi/client";

export default function useGetUsersOfMembership(membershipId?: string, retriggerReq?: number) {
  const [response, setResponse] = useState<PartnerUserBriefResponse[]>();

  const getMembershipInfo = async (membershipId: string) => {
    try {
      const res = await Api.Membership.getUsersOfMembershipByAdmin(membershipId);
      setResponse(res.data);
      return res.data;
    } catch (error) {
      setResponse(undefined);
      return undefined;
    }
  };

  const checkMembershipInfo = async (phoneNumber: string) => {
    try {
      const res = await Api.Membership.checkMembershipByAdmin(phoneNumber);
      return res.data;
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    if (membershipId) getMembershipInfo(membershipId);
  }, [membershipId, retriggerReq]);
  return { users: response, membershipId: response?.[0]?.id, getMembershipInfo, checkMembershipInfo };
}
